/** @jsx jsx */
import { jsx, css } from "@emotion/core";

const Output = ({ title, img }) => (
  <div css={styles} className="output">
    <img src={img} alt="class" />
    <h2>{title}</h2>
  </div>
);

const styles = css`
  text-align: left;
  img {
    
    width: 100%;
    height: auto;
    display: block;
  }
  h2 {
    margin: 39px 0 0 0;
    font-size: 29px;
    font-weight: 400;
    line-height: 1;
    color:red;
    
  }
  
  @media(max-width: 900px){
    img{
      height: 340px;
    }
  }
`;

export default Output;
